import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "font-sans"
}
const _hoisted_2 = { class: "flex flex-col p-4 pt-6 divide-y divide-brand-dark-gray" }
const _hoisted_3 = {
  key: 0,
  class: "flex text-white p-4 py-5"
}
const _hoisted_4 = { class: "flex justify-between" }
const _hoisted_5 = {
  key: 0,
  class: "text-lg"
}
const _hoisted_6 = {
  key: 1,
  class: "animate-spin m-auto h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_7 = { class: "flex justify-between" }
const _hoisted_8 = { class: "flex space-x-2" }
const _hoisted_9 = {
  key: 0,
  class: "text-lg"
}
const _hoisted_10 = {
  key: 1,
  class: "animate-spin m-auto h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

import {computed, inject, onDeactivated, onMounted, onUnmounted, PropType, Ref, ref, watch} from 'vue';
import {useRoute} from "vue-router";
import {alertController, IonContent, IonToggle, modalController, toastController} from "@ionic/vue";
import ApiService from "@/services/api/apiService";
import {FeedPostInterface} from "@/interfaces/FeedPostInterface";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {Preferences} from "@capacitor/preferences";
import {PreferenceKey} from "@/definitions/PreferenceKey";
import FeedNewPostPage from "@/views/feed/FeedNewPostPage.vue";
import {useUser} from "@/composables/useUser";
import {EventTypeModel} from "@/definitions/EventTypeModel";
import FeedNewVideoPage from "@/views/feed/FeedNewVideoPage.vue";
import {ReviewInterface} from "@/interfaces/ReviewInterface";



export default /*@__PURE__*/_defineComponent({
  __name: 'UserReviewContextMenu',
  props: {
  review: {
    type: Object as PropType<ReviewInterface>,
    required: true
  },
},
  setup(__props) {


const loading = ref(true)
const reportBusy = ref(false)
const deleteBusy = ref(false)

const authUserId = ref()

const props = __props

onMounted(async () => {
  authUserId.value = parseInt((await Preferences.get({key: PreferenceKey.UserId})).value as string)
  loading.value = false
})

const deleteReview = async () => {

  if (isBusy.value) return

  const alertCtrl = await alertController.create({
    header: 'Delete',
    message: 'Are you sure you want to delete this?',
    buttons: [
      {
        text: 'Yes',
        role: 'destructive',
        handler: async () => {
          try {
            deleteBusy.value = true
            await alertCtrl.dismiss()
            await ApiService.User().deleteReview(props.review)
            Observable.emit(ObservableEvent.UserReviewsChanged)
            await modalController.dismiss()
            deleteBusy.value = false
          } catch (e: any) {
            const toast = await toastController.create({
              message: e.data.message,
              duration: 3000,
              position: 'bottom',
              color: 'danger'
            });
            await toast.present();
            deleteBusy.value = false
          }
        }
      },
      {
        text: 'No',
      }
    ]
  })

  await alertCtrl.present()

}

const reviewRef: Ref<ReviewInterface> = ref(props.review)

const isBusy = computed(() => {
  return reportBusy.value || deleteBusy.value
})

const reportReview = async () => {
  if (isBusy.value) return
  try {

    const alert = await alertController.create({
      header: 'Report?',
      message: 'Are you sure you want to report this?',
      buttons: [
        {
          text: 'Cancel',
        },
        {
          text: 'Yes',
          role: 'destructive',
          handler: async () => {

            alertController.dismiss()
            reportBusy.value = true
            await ApiService.User().reportReview(props.review.id)
            Observable.emit(ObservableEvent.UserReviewsChanged)
            reportBusy.value = false

            await modalController.dismiss()
            const toast = await toastController.create({
              header: 'Reported',
              message: 'Thank you for reporting this, it has been flagged for review by our team.',
              duration: 3000,
              position: 'bottom',
              color: 'primary'
            });
            await toast.present();

          }
        },

      ]
    })
    await alert.present()

  } catch (e: any) {
    const toast = await toastController.create({
      message: e.data.message,
      duration: 3000,
      position: 'bottom',
      color: 'danger'
    });
    await toast.present();
    reportBusy.value = false
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (authUserId.value && authUserId.value !== __props.review.reviewer.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                      onClick: reportReview,
                      class: "flex space-x-2"
                    }, [
                      _cache[1] || (_cache[1] = _createElementVNode("svg", {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M21.8998 20.25L12.1498 3.375C12.0045 3.12422 11.7537 3 11.5006 3C11.2475 3 10.9943 3.12422 10.8514 3.375L1.10138 20.25C0.813094 20.7516 1.17403 21.375 1.75059 21.375H21.2506C21.8272 21.375 22.1881 20.7516 21.8998 20.25ZM10.7506 9.9375C10.7506 9.83437 10.835 9.75 10.9381 9.75H12.0631C12.1662 9.75 12.2506 9.83437 12.2506 9.9375V14.25C12.2506 14.3531 12.1662 14.4375 12.0631 14.4375H10.9381C10.835 14.4375 10.7506 14.3531 10.7506 14.25V9.9375ZM11.5006 18.1875C11.2062 18.1815 10.9259 18.0603 10.7198 17.85C10.5137 17.6397 10.3983 17.357 10.3983 17.0625C10.3983 16.768 10.5137 16.4853 10.7198 16.275C10.9259 16.0647 11.2062 15.9435 11.5006 15.9375C11.795 15.9435 12.0753 16.0647 12.2814 16.275C12.4874 16.4853 12.6029 16.768 12.6029 17.0625C12.6029 17.357 12.4874 17.6397 12.2814 17.85C12.0753 18.0603 11.795 18.1815 11.5006 18.1875Z",
                          fill: "white"
                        })
                      ], -1)),
                      (!reportBusy.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Report"))
                        : _createCommentVNode("", true),
                      (reportBusy.value)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_6, [...(_cache[0] || (_cache[0] = [
                            _createElementVNode("circle", {
                              class: "opacity-25",
                              cx: "12",
                              cy: "12",
                              r: "10",
                              stroke: "currentColor",
                              "stroke-width": "4"
                            }, null, -1),
                            _createElementVNode("path", {
                              class: "opacity-75",
                              fill: "currentColor",
                              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            }, null, -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (authUserId.value && authUserId.value === __props.review.reviewer.id)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  onClick: deleteReview,
                  class: "flex text-white p-4 py-5"
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _cache[3] || (_cache[3] = _createElementVNode("svg", {
                        width: "24",
                        height: "25",
                        viewBox: "0 0 24 25",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M21.1667 6.1H17.8333V4.1C17.8333 3.2175 17.0859 2.5 16.1667 2.5H7.83333C6.91406 2.5 6.16667 3.2175 6.16667 4.1V6.1H2.83333C2.3724 6.1 2 6.4575 2 6.9V7.7C2 7.81 2.09375 7.9 2.20833 7.9H3.78125L4.42448 20.975C4.46615 21.8275 5.20052 22.5 6.08854 22.5H17.9115C18.8021 22.5 19.5339 21.83 19.5755 20.975L20.2187 7.9H21.7917C21.9062 7.9 22 7.81 22 7.7V6.9C22 6.4575 21.6276 6.1 21.1667 6.1ZM15.9583 6.1H8.04167V4.3H15.9583V6.1Z",
                          fill: "white"
                        })
                      ], -1)),
                      (!deleteBusy.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Delete"))
                        : _createCommentVNode("", true),
                      (deleteBusy.value)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_10, [...(_cache[2] || (_cache[2] = [
                            _createElementVNode("circle", {
                              class: "opacity-25",
                              cx: "12",
                              cy: "12",
                              r: "10",
                              stroke: "currentColor",
                              "stroke-width": "4"
                            }, null, -1),
                            _createElementVNode("path", {
                              class: "opacity-75",
                              fill: "currentColor",
                              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            }, null, -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "safe-area-bottom" }, null, -1))
  ], 64))
}
}

})